import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import styled from 'styled-components';
import { getBreadCrumbItemsWithLinks } from './breadcrumb.utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BreadCrumbWrapper = styled.div.withConfig({
  displayName: "bread-crumb__BreadCrumbWrapper",
  componentId: "sc-pqlycx-0"
})(["position:relative;width:100%;&::after{content:'';position:absolute;left:-24px;right:-24px;bottom:0;}"]);
var StyledBreadCrumb = styled.nav.withConfig({
  displayName: "bread-crumb__StyledBreadCrumb",
  componentId: "sc-pqlycx-1"
})(["display:flex;align-items:center;gap:8px;color:rgba(0,0,0,0.45);font-size:14px;line-height:30px;"]);
var BreadCrumbItemText = styled.span.withConfig({
  displayName: "bread-crumb__BreadCrumbItemText",
  componentId: "sc-pqlycx-2"
})(["color:", ";font-weight:", ";"], function (_ref) {
  var $isLast = _ref.$isLast;
  return $isLast ? 'rgba(0, 0, 0, 0.88)' : 'rgba(0, 0, 0, 0.45)';
}, function (_ref2) {
  var $isLast = _ref2.$isLast;
  return $isLast ? 600 : 'normal';
});
var BreadCrumbLink = styled.a.withConfig({
  displayName: "bread-crumb__BreadCrumbLink",
  componentId: "sc-pqlycx-3"
})(["color:", ";font-weight:", ";text-decoration:none;&:hover{color:rgba(0,0,0,0.88);text-decoration:underline;}"], function (_ref3) {
  var $isLast = _ref3.$isLast;
  return $isLast ? 'rgba(0, 0, 0, 0.88)' : 'rgba(0, 0, 0, 0.45)';
}, function (_ref4) {
  var $isLast = _ref4.$isLast;
  return $isLast ? 600 : 'normal';
});
var Separator = styled.span.withConfig({
  displayName: "bread-crumb__Separator",
  componentId: "sc-pqlycx-4"
})(["color:rgba(0,0,0,0.35);"]);

var buildMenuRootHref = function buildMenuRootHref(url, baseUrl, root, level) {
  try {
    var parsedUrl = new URL(url, baseUrl);
    var menu = parsedUrl.searchParams.get('menu');
    if (!menu) return undefined;
    var base = "".concat(baseUrl.replace(/\/$/, '')).concat(root ? "/".concat(root) : '');
    var menuLevel = level !== null && level !== void 0 ? level : 1;
    return "".concat(base, "?menu=").concat(menu, "&level=").concat(menuLevel);
  } catch (_unused) {
    return undefined;
  }
};

export var BreadCrumb = function BreadCrumb(_ref5) {
  var root = _ref5.root,
      rootPageName = _ref5.rootPageName,
      url = _ref5.url,
      baseUrl = _ref5.baseUrl,
      menuOverrides = _ref5.menuOverrides,
      dashboardPath = _ref5.dashboardPath,
      level = _ref5.level,
      extraItems = _ref5.extraItems,
      t = _ref5.t;
  var items = useMemo(function () {
    var _extraItems;

    var baseItems = getBreadCrumbItemsWithLinks({
      root: root,
      rootPageName: rootPageName,
      url: url,
      baseUrl: baseUrl,
      menuOverrides: menuOverrides,
      dashboardPath: dashboardPath,
      level: level
    }).map(function (item) {
      if (!t) return item;
      var translationKey = item.label.toLowerCase().replace(/\s+/g, '');
      var translatedLabel = t(translationKey);
      return _objectSpread(_objectSpread({}, item), {}, {
        label: translatedLabel && translatedLabel !== translationKey ? translatedLabel : item.label
      });
    });

    if (!(extraItems !== null && extraItems !== void 0 && extraItems.length)) {
      return baseItems;
    }

    var extrasIncludeCurrent = !((_extraItems = extraItems[extraItems.length - 1]) !== null && _extraItems !== void 0 && _extraItems.href);

    if (extrasIncludeCurrent) {
      // Workspace folder trail: Your work > Workspace > Folder > Current folder
      var linkedBaseItems = baseItems.map(function (item, index) {
        if (index < baseItems.length - 1 || item.href) {
          return item;
        }

        var href = buildMenuRootHref(url, baseUrl, root, level);
        return href ? _objectSpread(_objectSpread({}, item), {}, {
          href: href
        }) : item;
      });
      return [].concat(_toConsumableArray(linkedBaseItems), _toConsumableArray(extraItems));
    } // Form edit trail: Space > Folder… > Form name (current)


    var head = baseItems.slice(0, -1);
    var current = baseItems[baseItems.length - 1];
    var linkedHead = head.map(function (item, index) {
      if (item.href) return item;

      if (index === head.length - 1) {
        var href = buildMenuRootHref(url, baseUrl, root, level);
        return href ? _objectSpread(_objectSpread({}, item), {}, {
          href: href
        }) : item;
      }

      return item;
    });
    return [].concat(_toConsumableArray(linkedHead), _toConsumableArray(extraItems), [current]);
  }, [root, rootPageName, url, baseUrl, menuOverrides, dashboardPath, level, extraItems, t]);
  return /*#__PURE__*/_jsx(BreadCrumbWrapper, {
    children: /*#__PURE__*/_jsx(StyledBreadCrumb, {
      "aria-label": "Breadcrumb",
      children: items.map(function (item, index) {
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [index > 0 && /*#__PURE__*/_jsx(Separator, {
            children: " > "
          }), item.href && index < items.length - 1 ? /*#__PURE__*/_jsx(BreadCrumbLink, {
            href: item.href,
            $isLast: false,
            children: item.label
          }) : /*#__PURE__*/_jsx(BreadCrumbItemText, {
            $isLast: index === items.length - 1,
            children: item.label
          })]
        }, "".concat(item.label, "-").concat(index));
      })
    })
  });
};
BreadCrumb.displayName = 'BreadCrumb';
export { getBreadCrumbItems, getBreadCrumbItemsWithLinks, normalizeLabel } from './breadcrumb.utils';